import Stack from "@mui/material/Stack";
import { HeadingL, useIsDesktop } from '@repo/ui';
import { useFormikContext } from "formik";
import { type FC } from "react";
import InformationList from "../../../InformationList";

const ChangesOverview: FC = () => {
	const { values } = useFormikContext();

	const content = (
		<>
			<HeadingL>Přehled změn</HeadingL>
			<InformationList
				information={[
					{
						title: "Nová výše příspěvku",
						description: `${values.monthlyContribution} Kč`,
					},
					{
						title: "Přispívá mi i zaměstnavatel",
						description: values.doesEmployerContribute ? "Ano" : "Ne",
						valueSelector: "pension-employer-contribution-change-overview",
					},
				]}
			/>
		</>
	);

	if (useIsDesktop()) return content;

	return <Stack spacing={5}>{content}</Stack>;
}

export default ChangesOverview;
